export * from './visit-admissions-result.component';
